/**
 * IP-based geolocation fallback
 */

export async function getLocationByIp() {
    const response = await fetch('/v1/geo/nearest');
    const data = await response.json();

    if (data && data.data) {
        const nearestCity = data.data;

        if (nearestCity.lat && nearestCity.lon) {
            return {
                lat: nearestCity.lat,
                lon: nearestCity.lon
            };
        }
    }

    throw new Error('No coordinates in IP response');
}
